import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const TimezoneInput = ({name, label, options, isLoading, isSubmitting, load, ...props}) => {

  // load timezones on mount
  useEffect(() => {
    load();
  }, [load]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label ? label : t('timezone_timezones')}
          rules={[
            {required: true, message: t('feedback_validation_required')},
          ]}
        >
          <Select
            showSearch
            disabled={isLoading || isSubmitting}
            loading={isLoading}
          >
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default TimezoneInput;
